import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { LessonStatus, Teacher } from '@df/interfaces';
import { ActivatedRoute } from '@angular/router';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { AccountService } from '@app/teacher/services/account.service';

@Component({
    selector: 'app-analysis-list-subject',
    templateUrl: './analysis-list-subject.component.html',
    styleUrls: ['./analysis-list-subject.component.scss']
})
export class AnalysisListSubjectComponent implements OnInit, OnDestroy {
    public headerName: string = 'Завершенные уроки';
    public classId: number;
    public subjectId: number;
    public teacher: Teacher;
    public lesson_completed = LessonStatus.LESSON_COMPLETED;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private accountService: AccountService,
        private route: ActivatedRoute,
        private teacherService: TeacherService
    ) {}

    public ngOnInit(): void {
        this.accountService.$currentTeacher.pipe(takeUntil(this.destroy$)).subscribe((teacher: Teacher) => {
            this.teacher = teacher;
        });

        this.route.parent.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
            this.subjectId = +params['subject_id'];
            this.classId = +params['class_id'];
            this.teacherService.setClassId(+params['class_id']);
            this.teacherService.setSubjectId(+params['subject_id']);
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
